<template>
  <v-card class="d-flex flex-column">
    <v-tooltip top v-for="action in actions" :key="action.id">
      <template v-slot:activator="{ on }">
        <Button
          v-if="action.id !== 'addMedia'"
          v-on="on"
          :color="action.color"
          :icon="action.icon"
          :disabled="disabled"
          @click="$emit(action.id)"
        />
        <MediaManagementWrapper
          v-else
          class="d-flex flex-column justify-center align-center"
          :initialImages="referenceMedia"
          @change="$emit('addMedia', $event)"
        >
          <template slot-scope="{ selectFile }">
            <Button
              v-on="on"
              :color="action.color"
              :icon="action.icon"
              @click="selectFile"
              :disabled="disabled"
            />
          </template>
        </MediaManagementWrapper>
      </template>
      {{ action.text }}
    </v-tooltip>
  </v-card>
</template>

<script>
import _ from 'lodash'
import MediaManagementWrapper from '@/components/utils/MediaManagementWrapper/MediaManagementWrapper.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'ItemMenu',

  components: {
    MediaManagementWrapper,
    Button,
  },

  props: {
    type: { required: false, type: String, default: 'text' },
    hasDescriptionActive: { required: false, type: Boolean },
    hasMediaActive: { required: false, type: Boolean },
    referenceMedia: { required: false, type: Array },
    disabled: Boolean,
  },

  computed: {
    actions() {
      return _.compact([
        {
          id: 'addItem',
          icon: 'mdi-plus-circle-outline',
          text: this.$t('checklist.add_item'),
          color: 'blueGrey',
        },
        this.type === 'separator'
          ? {
              id: 'copySection',
              icon: 'mdi-content-copy',
              text: this.$t('checklist.copy_section'),
              color: 'blueGrey',
            }
          : {
              id: 'copyItem',
              icon: 'mdi-content-copy',
              text: this.$t('checklist.copy_item'),
              color: 'blueGrey',
            },
        this.type !== 'separator' && {
          id: 'addMedia',
          icon: 'mdi-image-outline',
          text: this.$t('checklist.add_media'),
          color: 'blueGrey',
        },
        {
          id: 'addDescription',
          icon: 'mdi-card-text-outline',
          text: this.hasDescriptionActive
            ? this.$t('checklist.remove_description')
            : this.$t('checklist.add_description'),
          color: this.hasDescriptionActive ? 'grey' : 'blueGrey',
        },
        {
          id: 'addSeparator',
          icon: 'mdi-view-stream-outline',
          text: this.$t('checklist.add_separator'),
          color: 'blueGrey',
        },
        {
          id: 'removeItem',
          icon: 'mdi-delete-outline',
          text: this.$t('checklist.delete_item'),
          color: 'blueGrey',
        },
      ])
    },
  },
}
</script>
